import { ChangeDetectionStrategy, Component, EventEmitter, forwardRef, Injector, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from '../../value-accessor/value-accessor';

@Component({
    selector: 'density-user-picker',
    templateUrl: './density-user-picker.component.html',
    styleUrl: './density-user-picker.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DensityUserPickerComponent),
            multi: true
        }
    ]
})
export class DensityUserPickerComponent extends ValueAccessor<any> {
    private static nextId = 0;

    @Input()
    inputId: string = `density-user-picker-${DensityUserPickerComponent.nextId++}`;

    @Input()
    label: string = '';

    @Input()
    placeholder: string = '';

    @Input()
    isDisabled: boolean = false;

    @Input()
    invalid: boolean = false;

    @Input()
    styleClass: string = '';

    @Input()
    currentUser: { firstName: string; lastName: string; qNumber: string; [key: string]: any } | null = null;

    @Input()
    isLoading: boolean = false;

    @Input()
    isExternalLoading: boolean = false;

    @Input()
    displayWith: ((value: any) => string) | null = null;

    @Output()
    searchClicked = new EventEmitter<void>();

    @Output()
    currentUserAssigned = new EventEmitter<any>();

    @Output()
    cleared = new EventEmitter<void>();

    constructor(injector: Injector) {
        super(injector);
    }

    get displayValue(): string {
        if (this.value === null || this.value === undefined) {
            return '';
        }
        if (this.displayWith) {
            return this.displayWith(this.value);
        }
        if (typeof this.value === 'object') {
            if (this.value.firstName && this.value.lastName) {
                return `${this.value.firstName} ${this.value.lastName}`;
            }
            return '';
        }
        return this.value;
    }

    onInputChange(val: string) {
        this.value = val;
    }

    onSearchClick() {
        this.searchClicked.emit();
    }

    onAssignCurrentUserClick() {
        if (this.currentUser) {
            this.value = `${this.currentUser.firstName} ${this.currentUser.lastName}`;
            this.currentUserAssigned.emit(this.currentUser);
        }
    }

    onClear() {
        this.value = null;
        this.cleared.emit();
    }
}
